export const NorthArrow = () => {
  return (
    <g transform="translate(370, 25)">
      <polygon
        points="0,-8 -3,3 0,1 3,3"
        fill="#ffffff"
        stroke="rgba(0,0,0,0.5)"
        strokeWidth="0.5"
        opacity="0.9"
      />
      <text
        x="0"
        y="15"
        fontSize="8"
        fill="#ffffff"
        textAnchor="middle"
        opacity="0.9"
        className="font-bold"
      >
        N
      </text>
    </g>
  );
};
